import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ApiService } from "src/app/api.service";

@Component({
	selector: "app-enable-mfa",
	templateUrl: "./enable-mfa.component.html",
	styleUrls: ["./enable-mfa.component.scss"]
})
export class EnableMfaComponent implements OnInit {
	public mfaInfo: any;
	public mfa_code: string;
	public errormessage: string;

	constructor(private router: Router, private api: ApiService) { }

	async ngOnInit() {
		try {
			this.mfaInfo = await this.api.GetMfaQrCode();
		} catch (err) {
			if (err?.error?.message === "Affected 0 rows") {
				this.errormessage = "MFA is already enabled on this account.";
				this.router.navigate(["/dash/account"]);
			} else {
				this.errormessage = "Failed to enable MFA. Please try again.";
			}
		}
	}

	async EnableMFA() {
		if (!this.mfa_code) return;
		await this.api.EnableMFA(this.mfa_code);
		setTimeout(() => {
			this.router.navigate(["/dash/account"]);
		}, 1000);
	}
}
